import { Injectable } from '@angular/core';
import { ClientUtilsService } from './clientutils.service'; // adjust the path as needed
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class GetUtilsService {
  constructor(private clientUtils: ClientUtilsService) {}

  /**
   * Sends a request for a single document.
ng serg   *
   * The client's get() API does not support a mapping type under the default
   * API version, so the request path is built explicitly to keep the type.
   */
  get(index: string, type: string, id: string): Observable<any> {
    return new Observable((observer) => {
      const docType = type && type.length > 0 ? type : 'envelopes';
      const path = `/${encodeURIComponent(index)}/${encodeURIComponent(docType)}/${encodeURIComponent(id)}`;

      this.clientUtils.getClient().transport.request({
        method: 'GET',
        path: path
      }, (error: any, response: any) => {
        if (error) {
          observer.error(error);
        } else {
          observer.next(response);
        }
        observer.complete();
      });
    }).pipe(
      catchError((error) => throwError(() => error))
    );
  }

  /**
   * Sends a request for multiple documents.
   */
  mget(requestId: string, documents: any[], webContents: any): void {
    this.clientUtils.getClient().mget({
      body: {
        docs: this.getDocs(documents)
      }
    }, (error: any, response: any) => {
      const responseMessage = {
        id: requestId,
        response: response,
        error: error
      };

      if (typeof webContents === 'function') {
        webContents(responseMessage);
      } else {
        webContents.send('elastic-mget-response', responseMessage);
      }
    });
  }

  private getDocs(documents: any[]): any[] {
    return documents.map(document => ({
      _index: document.index,
      _type: document.type,
      _id: document.id
    }));
  }
}
